export class ArrayUtil {
  static getLast(array: any[]): any {
    array = array || [];
    return array.find((item, index) => (array.length - 1) === index);
  }
}
